const NaturalSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      <path
        d="M32.7 39.5s21 13.5 21 22.2m-1.3-12.4c-.2-16.6-27.3-15.9-27.3-15.9h0S27.3 58 44.4 56.8"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      ></path>
      <path
        d="M68.9 71l6.9-9.9 1.3-1.8 3-4.3.8.6c1.4.9 3.2.6 4.2-.7.9-1.4.6-3.2-.7-4.2l-9.8-6.9c-1.4-.9-3.2-.6-4.2.7-.9 1.4-.6 3.2.7 4.2l.8.6-6.2 8.9-1.4 2-7.5 10.7"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      ></path>
      <path
        d="M88.9 66.7v14c0 7.7-9 14-20 14h-10c-11 0-20-6.3-20-14v-14M60 59.3c-.9 0-1.7.1-2.5.2m-8 1.1c-6.4 1.4-10.6 3.6-10.6 6.1 0 3.1 6.1 5.7 14.9 6.9 1.7.2 3.5.4 5.4.5 1.5.1 3.1.1 4.7.1h2.5c1.8-.1 3.6-.2 5.3-.3 10-1 17.2-3.8 17.2-7.1 0-2.2-3.2-4.2-8.2-5.5"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      ></path>
    </svg>
  );
};

export default NaturalSVG;
